import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/utils/cn';

const buttonVariants = cva(
    'focus-ring inline-flex items-center justify-center gap-2 rounded-[0.5rem] text-[13px] font-bold transition disabled:cursor-not-allowed disabled:opacity-50',
    {
        variants: {
            variant: {
                primary:   'bg-brand-navy text-white hover:bg-brand-navy-600',
                secondary: 'border border-ink-100 bg-white text-brand-navy hover:bg-brand-navy-50',
                ghost:     'text-ink-700 hover:bg-ink-50',
                danger:    'bg-red-600 text-white hover:bg-red-700',
            },
            size: {
                sm: 'h-8 px-3 text-xs',
                md: 'h-8 px-4',
                lg: 'h-12 px-5 text-base',
                icon: 'h-9 w-9',
            },
        },
        defaultVariants: { variant: 'primary', size: 'md' },
    },
);

export interface ButtonProps
    extends ButtonHTMLAttributes<HTMLButtonElement>,
        VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, variant, size, type = 'button', ...props }, ref) => (
        <button ref={ref} type={type} className={cn(buttonVariants({ variant, size }), className)} {...props} />
    ),
);
Button.displayName = 'Button';
